/* eslint-disable */
import { environment } from "../../environments/environment";

interface RequestOptions extends RequestInit {
  method: string;
  headers: Record<string, string>;
  body?: string;
}

export const fetchWrapper = {
  get: request('GET'),
  post: request('POST'),
  put: request('PUT'),
  delete: request('DELETE'),
};

function request(method: string) {
  return (url: string, body?: object) => {
    const init: RequestOptions = {
      method,
      headers: authHeader(url)
    };

    if (body && init.headers) {
      init.headers['Content-Type'] = 'application/json';
      init.body = JSON.stringify(body);
    }

    return fetch(url, init).then(handleResponseJson);
  };
}

// Helper functions

function authHeader(url: string): Record<string, string> {
  const token = authToken();
  const isLoggedIn = !!token;
  const apiUrls = environment.localApiAuth.apiUrls;

  if (isLoggedIn && apiUrls.some(apiUrl => url.startsWith(apiUrl))) {
    // TODO: Add proper palBranchId value
    return {
      Authorization: `Bearer ${token}`,
      palBranchId: "1"
    };
  } else {
    return {};
  }
}

function authToken(): string | null {
  return sessionStorage.getItem('palAuth');
}

export async function handleResponseJson(response: Response): Promise<any> {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);

    if (!response.ok) {
      if ([401, 403].includes(response.status) && authToken()) {
        // Auto logout if 401 Unauthorized or 403 Forbidden response returned from API
        // logout();
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

function handleResponseDocument(response: Response): Promise<any> {
  return response.blob().then((text) => {
    const data = text

    if (!response.ok) {
      if ([401, 403].includes(response.status) && authToken()) {
        // Auto logout if 401 Unauthorized or 403 Forbidden response returned from API
        // logout();
      }

      const error = (data) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}